import { IconList, IconUser } from '@tabler/icons';
import HubIcon from '@mui/icons-material/Hub';
import TagIcon from '@mui/icons-material/Tag';
import DashboardIcon from '@mui/icons-material/Dashboard';
import BusinessIcon from '@mui/icons-material/Business';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import GroupsIcon from '@mui/icons-material/Groups';

const pages = {
    id: 'main',
    type: 'group',
    children: [
        {
            id: 'dashboard',
            title: 'Home',
            type: 'item',
            url: '/home',
            icon: DashboardIcon,
            breadcrumbs: false,
            role: ['User', 'Admin']
        },
        {
            id: 'asset',
            title: 'ASSETS',
            type: 'item',
            url: '/assets',
            icon: IconList,
            breadcrumbs: false,
            role: ['User', 'Admin']
        },
        {
            id: 'halog',
            title: 'DEVICES',
            type: 'item',
            url: '/halogs',
            icon: () => '',
            breadcrumbs: false,
            role: ['Admin']
        },
        {
            id: 'user',
            title: 'USERS',
            type: 'item',
            url: '/users',
            icon: IconUser,
            breadcrumbs: false,
            role: ['Admin']
        },
        {
            id: 'userGroups',
            title: 'USER_GROUPS',
            type: 'item',
            url: '/user-groups',
            icon: GroupsIcon,
            breadcrumbs: false,
            role: ['Admin']
        },
        {
            id: 'gateway',
            title: 'Gateways',
            type: 'item',
            url: '/gateways',
            icon: HubIcon,
            breadcrumbs: false,
            role: ['Sys_Admin']
        },
        {
            id: 'tag',
            title: 'Tags',
            type: 'item',
            url: '/tags',
            icon: TagIcon,
            breadcrumbs: false,
            role: ['Admin', 'User']
        },
        {
            id: 'tenant',
            title: 'Tenants',
            type: 'item',
            url: '/tenants',
            icon: BusinessIcon,
            breadcrumbs: false,
            role: ['Sys_Admin']
        },
        {
            id: 'systemAdminUsers',
            title: 'SYSTEM_ADMINS',
            type: 'item',
            url: '/system-admin-users',
            icon: SupervisorAccountIcon,
            breadcrumbs: false,
            role: ['Sys_Admin']
        },
        {
            id: 'firmware',
            title: 'Firmwares',
            type: 'item',
            url: '/firmwares',
            icon: SettingsApplicationsIcon,
            breadcrumbs: false,
            role: ['Sys_Admin']
        }
    ]
};

export default pages;
